import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { AppBar, Dialog, DialogContent, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Movement from './configuration/Movement';
import { BASE_ADMIN_API_URL } from '../../../../config';
import { useFetch } from '../../../../hooks/use-fetch';
import { useTranslation } from 'react-i18next';
import { useMovementLoadListAction } from './movements-load-list';
import { useWaitUntilJobsFinished } from '../../../devices';

export const useMovementWriteAction = (sn) => {
    const fetch = useFetch();
    return useCallback(async (key, payload) => {
        try {
            const response = await fetch(
                `${BASE_ADMIN_API_URL}/actions/devices/${sn}/movements/write-conf/${key}`,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload),
                });

            if (!response.ok) {
                throw new Error(await response.text());
            }
        } catch (e) {
            console.error(e);
        }

    }, []);
}

export const useConfigureMovementModalController = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return [open, handleOpen, handleClose];
}

export default function ConfigureMovementModal({ sn, open, onClose, movement }) {
    const { t } = useTranslation();
    const handleWriteConf = useMovementWriteAction(sn);

    const loadMovements = useMovementLoadListAction(sn);

    const waitUntilJobsFinished = useWaitUntilJobsFinished();

    const handleSubmit = async (values) => {
        await handleWriteConf(values.i, values);

        await waitUntilJobsFinished();

        await loadMovements();

        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} fullScreen fullWidth maxWidth='xl'>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        {movement && t('MOVE_CONF.TITLE_EXISTING') + ` ${movement.n}` || t('MOVE_CONF.TITLE_NEW')}
                    </Typography>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <Movement onSubmit={handleSubmit} movement={movement}></Movement>
            </DialogContent>
        </Dialog>
    )
}

ConfigureMovementModal.propTypes = {
    sn: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    movement: PropTypes.object,
}
